export const getLinksParams = {
  keywords: "lostworld_ios/lostworld_android/lostworld_pc"
}
